<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Diğer Bilgiler</b-card-title>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Adres Bilgileri">
                <b-form-input
                  v-model="addressFormData.address"
                  placeholder="Adres Bilgileri"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Telefonu">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    TR (+90)
                  </b-input-group-prepend>
                  <cleave
                    id="phone_business"
                    v-model="addressFormData.phone"
                    class="form-control"
                    :raw="false"
                    :options="options.phone"
                    placeholder="Telefonu"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Şehir">
                <v-select
                  v-model="addressFormData.id_cities"
                  :options="cities"
                  label="title"
                  :reduce="cities => cities.id"
                  placeholder="Şehir"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="İlçe">
                <v-select
                  v-model="addressFormData.id_districts"
                  :options="districts"
                  label="title"
                  :reduce="districts => districts.id"
                  placeholder="İlçe"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="addressSubmitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <b-card-title>Banka Bilgileri</b-card-title>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Banka Adı">
                <v-select
                  v-model="employeeBankFormData.id_banks"
                  :options="banks"
                  label="title"
                  :reduce="banks => banks.id"
                  placeholder="Banka Adı"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Hesap No">
                <b-form-input
                  v-model="employeeBankFormData.account_no"
                  placeholder="Hesap No"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="IBAN">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    TR
                  </b-input-group-prepend>
                  <cleave
                    id="iban"
                    v-model="employeeBankFormData.iban"
                    class="form-control"
                    :raw="false"
                    :options="options.iban"
                    placeholder="IBAN"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="bankSubmitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <b-card-title>Acil Durum Bilgileri</b-card-title>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Acil Durumda Aranacak Kişi">
                <b-form-input
                  v-model="addressFormData.emergency_name"
                  placeholder="Acil Durumda Aranacak Kişi"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Yakınlık Derecesi">
                <b-form-input
                  v-model="addressFormData.emergency_desc"
                  placeholder="Yakınlık Derecesi"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Telefonu">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    TR (+90)
                  </b-input-group-prepend>
                  <cleave
                    id="emergency_phone"
                    v-model="addressFormData.emergency_phone"
                    class="form-control"
                    :raw="false"
                    :options="options.phone"
                    placeholder="Telefonu"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="addressSubmitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BCard, BCardTitle, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BButton,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'Others',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormInput,
    BFormGroup,
    Cleave,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    vSelect,
  },
  data() {
    return {
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        block: {
          blocks: [11],
          uppercase: true,
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundreds',
        },
        iban: {
          blocks: [26],
        },
      },
      addressFormData: {
        address: null,
        phone: null,
        emergency_name: null,
        emergency_desc: null,
        emergency_phone: null,
        id_cities: null,
        id_districts: null,
      },
      employeeBankFormData: {
        account_no: null,
        iban: null,
        id_banks: null,
      },
    }
  },
  computed: {
    contacts() {
      return this.$store.getters['employeeContact/getEmployeeContacts']
    },
    contactsSaveStatus() {
      return this.$store.getters['employeeContact/getEmployeeContactSaveStatus']
    },
    cities() {
      return this.$store.getters['cities/getCities']
    },
    districts() {
      return this.$store.getters['districts/getDistricts']
    },
    banks() {
      return this.$store.getters['banks/getBanks']
    },
    employeeBanks() {
      return this.$store.getters['employeeBank/getEmployeeBanks']
    },
    employeeBankSaveStatus() {
      return this.$store.getters['employeeBank/getEmployeeBankSaveStatus']
    },
  },
  watch: {
    contacts(val) {
      this.addressSetFormData(val)
    },
    employeeBanks(val) {
      this.employeeBankSetFormData(val)
    },
    employeeBankSaveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
    contactsSaveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getEmployeeContact()
    this.getCities()
    this.getDistricts()
    this.getBanks()
    this.getEmployeeBank()
  },
  methods: {
    getEmployeeContact() {
      this.$store.dispatch('employeeContact/employeeContactsList', {
        where: {
          'employee_contact.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getCities() {
      this.$store.dispatch('cities/citiesList')
    },
    getDistricts() {
      this.$store.dispatch('districts/districtsList')
    },
    getBanks() {
      this.$store.dispatch('banks/banksList')
    },
    getEmployeeBank() {
      this.$store.dispatch('employeeBank/employeeBanksList', {
        where: {
          'employee_bank.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    addressSetFormData(data) {
      this.addressFormData = data
    },
    employeeBankSetFormData(data) {
      this.employeeBankFormData = data
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    addressSubmitForm() {
      this.submitStatus = true
      this.$store.dispatch('employeeContact/employeeContactSave', this.addressFormData)
    },
    bankSubmitForm() {
      this.submitStatus = true
      this.$store.dispatch('employeeBank/employeeBankSave', this.employeeBankFormData)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
